import React from 'react';
import * as LucideIcons from 'lucide-react';

export interface IconProps {
  name: string;
  size?: number;
  className?: string;
  color?: string;
}

export const renderIcon = ({
  name,
  size = 20,
  className = '',
  color,
}: IconProps): React.ReactNode => {
  // Convert kebab-case or snake_case to PascalCase for Lucide icon names
  const iconName = name
    .split(/[-_]/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join('');

  // Get the icon component from Lucide using a safer approach
  const IconComponent = (
    LucideIcons as unknown as Record<
      string,
      React.ComponentType<{
        size?: number;
        className?: string;
        color?: string;
      }>
    >
  )[iconName];

  if (!IconComponent) {
    return null;
  }

  return React.createElement(IconComponent, {
    size,
    className,
    color,
  });
};

// Type for icon names to help with TypeScript
export type LucideIconName = keyof typeof LucideIcons;
